var map = {
	"./accordion-arrow.svg": 7403,
	"./arrow.svg": 382,
	"./bigcommerce-logo.svg": 9334,
	"./magento1-logo.svg": 949,
	"./magento2-logo.svg": 4943,
	"./opencart-logo.svg": 5587,
	"./prestashop-logo.svg": 6160,
	"./shopify-logo.svg": 5205,
	"./shopware-logo.svg": 8568,
	"./trustpilot-logo.svg": 29,
	"./woocommerce-logo.svg": 5919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7895;